var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("b-dropdown-item", { attrs: { to: "/service-instance" } }, [
        _c(
          "span",
          {
            domProps: {
              textContent: _vm._s(
                _vm.$t("global.menu.entities.serviceInstance")
              ),
            },
          },
          [_vm._v("Service Instance")]
        ),
      ]),
      _vm._v(" "),
      _vm.hasAnyAuthority("ROLE_ADMIN") && _vm.authenticated
        ? [
            _c("b-dropdown-item", { attrs: { to: "/service-specification" } }, [
              _c(
                "span",
                {
                  domProps: {
                    textContent: _vm._s(
                      _vm.$t("global.menu.entities.serviceSpecification")
                    ),
                  },
                },
                [_vm._v("Service Specification")]
              ),
            ]),
            _vm._v(" "),
            _c(
              "b-dropdown-item",
              { attrs: { to: "/service-technical-design" } },
              [
                _c(
                  "span",
                  {
                    domProps: {
                      textContent: _vm._s(
                        _vm.$t("global.menu.entities.serviceTechnicalDesign")
                      ),
                    },
                  },
                  [_vm._v("Service Technical Design")]
                ),
              ]
            ),
            _vm._v(" "),
            _c("b-dropdown-item", { attrs: { to: "/author-info" } }, [
              _c(
                "span",
                {
                  domProps: {
                    textContent: _vm._s(
                      _vm.$t("global.menu.entities.authorInfo")
                    ),
                  },
                },
                [_vm._v("Author Info")]
              ),
            ]),
            _vm._v(" "),
            _c(
              "b-dropdown-item",
              { attrs: { to: "/data-model-description" } },
              [
                _c(
                  "span",
                  {
                    domProps: {
                      textContent: _vm._s(
                        _vm.$t("global.menu.entities.dataModelDescription")
                      ),
                    },
                  },
                  [_vm._v("Data Model Description")]
                ),
              ]
            ),
            _vm._v(" "),
            _c("b-dropdown-item", { attrs: { to: "/service-interface" } }, [
              _c(
                "span",
                {
                  domProps: {
                    textContent: _vm._s(
                      _vm.$t("global.menu.entities.serviceInterface")
                    ),
                  },
                },
                [_vm._v("Service Interface")]
              ),
            ]),
            _vm._v(" "),
            _c("b-dropdown-item", { attrs: { to: "/service-operation" } }, [
              _c(
                "span",
                {
                  domProps: {
                    textContent: _vm._s(
                      _vm.$t("global.menu.entities.serviceOperation")
                    ),
                  },
                },
                [_vm._v("Service Operation")]
              ),
            ]),
            _vm._v(" "),
            _c("b-dropdown-item", { attrs: { to: "/message" } }, [
              _c(
                "span",
                {
                  domProps: {
                    textContent: _vm._s(_vm.$t("global.menu.entities.message")),
                  },
                },
                [_vm._v("Message")]
              ),
            ]),
            _vm._v(" "),
            _c("b-dropdown-item", { attrs: { to: "/technology" } }, [
              _c(
                "span",
                {
                  domProps: {
                    textContent: _vm._s(
                      _vm.$t("global.menu.entities.technology")
                    ),
                  },
                },
                [_vm._v("Technology")]
              ),
            ]),
            _vm._v(" "),
            _c("b-dropdown-item", { attrs: { to: "/endpoint" } }, [
              _c(
                "span",
                {
                  domProps: {
                    textContent: _vm._s(
                      _vm.$t("global.menu.entities.endpoint")
                    ),
                  },
                },
                [_vm._v("Endpoint")]
              ),
            ]),
            _vm._v(" "),
            _c("b-dropdown-item", { attrs: { to: "/coverage-area" } }, [
              _c(
                "span",
                {
                  domProps: {
                    textContent: _vm._s(
                      _vm.$t("global.menu.entities.coverageArea")
                    ),
                  },
                },
                [_vm._v("Coverage Area")]
              ),
            ]),
            _vm._v(" "),
            _c(
              "b-dropdown-item",
              { attrs: { to: "/swsr-information-service" } },
              [
                _c(
                  "span",
                  {
                    domProps: {
                      textContent: _vm._s(
                        _vm.$t("global.menu.entities.swsrInformationService")
                      ),
                    },
                  },
                  [_vm._v("Swsr Information Service")]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "b-dropdown-item",
              { attrs: { to: "/swsr-service-provision" } },
              [
                _c(
                  "span",
                  {
                    domProps: {
                      textContent: _vm._s(
                        _vm.$t("global.menu.entities.swsrServiceProvision")
                      ),
                    },
                  },
                  [_vm._v("Swsr Service Provision")]
                ),
              ]
            ),
            _vm._v(" "),
            _c("b-dropdown-item", { attrs: { to: "/swsr-point-of-contact" } }, [
              _c(
                "span",
                {
                  domProps: {
                    textContent: _vm._s(
                      _vm.$t("global.menu.entities.swsrPointOfContact")
                    ),
                  },
                },
                [_vm._v("Swsr Point Of Contact")]
              ),
            ]),
            _vm._v(" "),
            _c(
              "b-dropdown-item",
              { attrs: { to: "/swsr-description-information" } },
              [
                _c(
                  "span",
                  {
                    domProps: {
                      textContent: _vm._s(
                        _vm.$t(
                          "global.menu.entities.swsrDescriptionInformation"
                        )
                      ),
                    },
                  },
                  [_vm._v("Swsr Description Information")]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "b-dropdown-item",
              { attrs: { to: "/swsr-service-description" } },
              [
                _c(
                  "span",
                  {
                    domProps: {
                      textContent: _vm._s(
                        _vm.$t("global.menu.entities.swsrServiceDescription")
                      ),
                    },
                  },
                  [_vm._v("Swsr Service Description")]
                ),
              ]
            ),
            _vm._v(" "),
            _c("b-dropdown-item", { attrs: { to: "/swsr-abbreviation" } }, [
              _c(
                "span",
                {
                  domProps: {
                    textContent: _vm._s(
                      _vm.$t("global.menu.entities.swsrAbbreviation")
                    ),
                  },
                },
                [_vm._v("Swsr Abbreviation")]
              ),
            ]),
            _vm._v(" "),
            _c(
              "b-dropdown-item",
              { attrs: { to: "/swsr-service-categorisation" } },
              [
                _c(
                  "span",
                  {
                    domProps: {
                      textContent: _vm._s(
                        _vm.$t("global.menu.entities.swsrServiceCategorisation")
                      ),
                    },
                  },
                  [_vm._v("Swsr Service Categorisation")]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "b-dropdown-item",
              {
                attrs: {
                  to: "/code-application-message-exchange-pattern-type-wrapper",
                },
              },
              [
                _c(
                  "span",
                  {
                    domProps: {
                      textContent: _vm._s(
                        _vm.$t(
                          "global.menu.entities.codeApplicationMessageExchangePatternTypeWrapper"
                        )
                      ),
                    },
                  },
                  [
                    _vm._v(
                      "Code Application Message Exchange Pattern Type Wrapper"
                    ),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "b-dropdown-item",
              { attrs: { to: "/code-business-activity-type-wrapper" } },
              [
                _c(
                  "span",
                  {
                    domProps: {
                      textContent: _vm._s(
                        _vm.$t(
                          "global.menu.entities.codeBusinessActivityTypeWrapper"
                        )
                      ),
                    },
                  },
                  [_vm._v("Code Business Activity Type Wrapper")]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "b-dropdown-item",
              { attrs: { to: "/code-information-exchange-category-wrapper" } },
              [
                _c(
                  "span",
                  {
                    domProps: {
                      textContent: _vm._s(
                        _vm.$t(
                          "global.menu.entities.codeInformationExchangeCategoryWrapper"
                        )
                      ),
                    },
                  },
                  [_vm._v("Code Information Exchange Category Wrapper")]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "b-dropdown-item",
              { attrs: { to: "/code-stakeholder-type-wrapper" } },
              [
                _c(
                  "span",
                  {
                    domProps: {
                      textContent: _vm._s(
                        _vm.$t(
                          "global.menu.entities.codeStakeholderTypeWrapper"
                        )
                      ),
                    },
                  },
                  [_vm._v("Code Stakeholder Type Wrapper")]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "b-dropdown-item",
              { attrs: { to: "/swsr-geographical-extent" } },
              [
                _c(
                  "span",
                  {
                    domProps: {
                      textContent: _vm._s(
                        _vm.$t("global.menu.entities.swsrGeographicalExtent")
                      ),
                    },
                  },
                  [_vm._v("Swsr Geographical Extent")]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "b-dropdown-item",
              { attrs: { to: "/aerodrome-icao-location-indicator" } },
              [
                _c(
                  "span",
                  {
                    domProps: {
                      textContent: _vm._s(
                        _vm.$t(
                          "global.menu.entities.aerodromeIcaoLocationIndicator"
                        )
                      ),
                    },
                  },
                  [_vm._v("Aerodrome Icao Location Indicator")]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "b-dropdown-item",
              { attrs: { to: "/fir-icao-location-indicator" } },
              [
                _c(
                  "span",
                  {
                    domProps: {
                      textContent: _vm._s(
                        _vm.$t("global.menu.entities.firIcaoLocationIndicator")
                      ),
                    },
                  },
                  [_vm._v("Fir Icao Location Indicator")]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "b-dropdown-item",
              { attrs: { to: "/state-icao-nationality-letters" } },
              [
                _c(
                  "span",
                  {
                    domProps: {
                      textContent: _vm._s(
                        _vm.$t(
                          "global.menu.entities.stateIcaoNationalityLetters"
                        )
                      ),
                    },
                  },
                  [_vm._v("State Icao Nationality Letters")]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "b-dropdown-item",
              { attrs: { to: "/swsr-service-description-references" } },
              [
                _c(
                  "span",
                  {
                    domProps: {
                      textContent: _vm._s(
                        _vm.$t(
                          "global.menu.entities.swsrServiceDescriptionReferences"
                        )
                      ),
                    },
                  },
                  [_vm._v("Swsr Service Description References")]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "b-dropdown-item",
              { attrs: { to: "/swsr-implemented-standard" } },
              [
                _c(
                  "span",
                  {
                    domProps: {
                      textContent: _vm._s(
                        _vm.$t("global.menu.entities.swsrImplementedStandard")
                      ),
                    },
                  },
                  [_vm._v("Swsr Implemented Standard")]
                ),
              ]
            ),
            _vm._v(" "),
            _c("b-dropdown-item", { attrs: { to: "/swsr-document" } }, [
              _c(
                "span",
                {
                  domProps: {
                    textContent: _vm._s(
                      _vm.$t("global.menu.entities.swsrDocument")
                    ),
                  },
                },
                [_vm._v("Swsr Document")]
              ),
            ]),
            _vm._v(" "),
            _c(
              "b-dropdown-item",
              { attrs: { to: "/swsr-service-technical-description" } },
              [
                _c(
                  "span",
                  {
                    domProps: {
                      textContent: _vm._s(
                        _vm.$t(
                          "global.menu.entities.swsrServiceTechnicalDescription"
                        )
                      ),
                    },
                  },
                  [_vm._v("Swsr Service Technical Description")]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "b-dropdown-item",
              { attrs: { to: "/swsr-security-mechanism" } },
              [
                _c(
                  "span",
                  {
                    domProps: {
                      textContent: _vm._s(
                        _vm.$t("global.menu.entities.swsrSecurityMechanism")
                      ),
                    },
                  },
                  [_vm._v("Swsr Security Mechanism")]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "b-dropdown-item",
              { attrs: { to: "/code-security-mechanism-type-wrapper" } },
              [
                _c(
                  "span",
                  {
                    domProps: {
                      textContent: _vm._s(
                        _vm.$t(
                          "global.menu.entities.codeSecurityMechanismTypeWrapper"
                        )
                      ),
                    },
                  },
                  [_vm._v("Code Security Mechanism Type Wrapper")]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "b-dropdown-item",
              { attrs: { to: "/swsr-service-monitoring" } },
              [
                _c(
                  "span",
                  {
                    domProps: {
                      textContent: _vm._s(
                        _vm.$t("global.menu.entities.swsrServiceMonitoring")
                      ),
                    },
                  },
                  [_vm._v("Swsr Service Monitoring")]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "b-dropdown-item",
              { attrs: { to: "/swsr-technical-constraint" } },
              [
                _c(
                  "span",
                  {
                    domProps: {
                      textContent: _vm._s(
                        _vm.$t("global.menu.entities.swsrTechnicalConstraint")
                      ),
                    },
                  },
                  [_vm._v("Swsr Technical Constraint")]
                ),
              ]
            ),
            _vm._v(" "),
            _c("b-dropdown-item", { attrs: { to: "/swsr-interface" } }, [
              _c(
                "span",
                {
                  domProps: {
                    textContent: _vm._s(
                      _vm.$t("global.menu.entities.swsrInterface")
                    ),
                  },
                },
                [_vm._v("Swsr Interface")]
              ),
            ]),
            _vm._v(" "),
            _c(
              "b-dropdown-item",
              { attrs: { to: "/swsr-service-behaviour" } },
              [
                _c(
                  "span",
                  {
                    domProps: {
                      textContent: _vm._s(
                        _vm.$t("global.menu.entities.swsrServiceBehaviour")
                      ),
                    },
                  },
                  [_vm._v("Swsr Service Behaviour")]
                ),
              ]
            ),
            _vm._v(" "),
            _c("b-dropdown-item", { attrs: { to: "/swsr-operation" } }, [
              _c(
                "span",
                {
                  domProps: {
                    textContent: _vm._s(
                      _vm.$t("global.menu.entities.swsrOperation")
                    ),
                  },
                },
                [_vm._v("Swsr Operation")]
              ),
            ]),
            _vm._v(" "),
            _c(
              "b-dropdown-item",
              { attrs: { to: "/ti-protocol-method-wrapper" } },
              [
                _c(
                  "span",
                  {
                    domProps: {
                      textContent: _vm._s(
                        _vm.$t("global.menu.entities.tiProtocolMethodWrapper")
                      ),
                    },
                  },
                  [_vm._v("Ti Protocol Method Wrapper")]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "b-dropdown-item",
              { attrs: { to: "/swsr-processing-consideration" } },
              [
                _c(
                  "span",
                  {
                    domProps: {
                      textContent: _vm._s(
                        _vm.$t(
                          "global.menu.entities.swsrProcessingConsideration"
                        )
                      ),
                    },
                  },
                  [_vm._v("Swsr Processing Consideration")]
                ),
              ]
            ),
            _vm._v(" "),
            _c("b-dropdown-item", { attrs: { to: "/swsr-message" } }, [
              _c(
                "span",
                {
                  domProps: {
                    textContent: _vm._s(
                      _vm.$t("global.menu.entities.swsrMessage")
                    ),
                  },
                },
                [_vm._v("Swsr Message")]
              ),
            ]),
            _vm._v(" "),
            _c("b-dropdown-item", { attrs: { to: "/swsr-end-point" } }, [
              _c(
                "span",
                {
                  domProps: {
                    textContent: _vm._s(
                      _vm.$t("global.menu.entities.swsrEndPoint")
                    ),
                  },
                },
                [_vm._v("Swsr End Point")]
              ),
            ]),
            _vm._v(" "),
            _c("b-dropdown-item", { attrs: { to: "/swsr-resource" } }, [
              _c(
                "span",
                {
                  domProps: {
                    textContent: _vm._s(
                      _vm.$t("global.menu.entities.swsrResource")
                    ),
                  },
                },
                [_vm._v("Swsr Resource")]
              ),
            ]),
            _vm._v(" "),
            _c(
              "b-dropdown-item",
              { attrs: { to: "/swsr-service-information-description" } },
              [
                _c(
                  "span",
                  {
                    domProps: {
                      textContent: _vm._s(
                        _vm.$t(
                          "global.menu.entities.swsrServiceInformationDescription"
                        )
                      ),
                    },
                  },
                  [_vm._v("Swsr Service Information Description")]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "b-dropdown-item",
              { attrs: { to: "/swsr-information-definition" } },
              [
                _c(
                  "span",
                  {
                    domProps: {
                      textContent: _vm._s(
                        _vm.$t("global.menu.entities.swsrInformationDefinition")
                      ),
                    },
                  },
                  [_vm._v("Swsr Information Definition")]
                ),
              ]
            ),
            _vm._v(" "),
            _c("b-dropdown-item", { attrs: { to: "/swsr-exchange-schema" } }, [
              _c(
                "span",
                {
                  domProps: {
                    textContent: _vm._s(
                      _vm.$t("global.menu.entities.swsrExchangeSchema")
                    ),
                  },
                },
                [_vm._v("Swsr Exchange Schema")]
              ),
            ]),
            _vm._v(" "),
            _c(
              "b-dropdown-item",
              { attrs: { to: "/swsr-service-general-description" } },
              [
                _c(
                  "span",
                  {
                    domProps: {
                      textContent: _vm._s(
                        _vm.$t(
                          "global.menu.entities.swsrServiceGeneralDescription"
                        )
                      ),
                    },
                  },
                  [_vm._v("Swsr Service General Description")]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "b-dropdown-item",
              { attrs: { to: "/swsr-quality-of-service" } },
              [
                _c(
                  "span",
                  {
                    domProps: {
                      textContent: _vm._s(
                        _vm.$t("global.menu.entities.swsrQualityOfService")
                      ),
                    },
                  },
                  [_vm._v("Swsr Quality Of Service")]
                ),
              ]
            ),
            _vm._v(" "),
            _c("b-dropdown-item", { attrs: { to: "/swsr-operational-need" } }, [
              _c(
                "span",
                {
                  domProps: {
                    textContent: _vm._s(
                      _vm.$t("global.menu.entities.swsrOperationalNeed")
                    ),
                  },
                },
                [_vm._v("Swsr Operational Need")]
              ),
            ]),
            _vm._v(" "),
            _c(
              "b-dropdown-item",
              { attrs: { to: "/swsr-validation-of-service" } },
              [
                _c(
                  "span",
                  {
                    domProps: {
                      textContent: _vm._s(
                        _vm.$t("global.menu.entities.swsrValidationOfService")
                      ),
                    },
                  },
                  [_vm._v("Swsr Validation Of Service")]
                ),
              ]
            ),
            _vm._v(" "),
            _c("b-dropdown-item", { attrs: { to: "/swsr-functionality" } }, [
              _c(
                "span",
                {
                  domProps: {
                    textContent: _vm._s(
                      _vm.$t("global.menu.entities.swsrFunctionality")
                    ),
                  },
                },
                [_vm._v("Swsr Functionality")]
              ),
            ]),
            _vm._v(" "),
            _c("b-dropdown-item", { attrs: { to: "/swsr-concept" } }, [
              _c(
                "span",
                {
                  domProps: {
                    textContent: _vm._s(
                      _vm.$t("global.menu.entities.swsrConcept")
                    ),
                  },
                },
                [_vm._v("Swsr Concept")]
              ),
            ]),
            _vm._v(" "),
            _c(
              "b-dropdown-item",
              { attrs: { to: "/swsr-access-and-use-condition" } },
              [
                _c(
                  "span",
                  {
                    domProps: {
                      textContent: _vm._s(
                        _vm.$t("global.menu.entities.swsrAccessAndUseCondition")
                      ),
                    },
                  },
                  [_vm._v("Swsr Access And Use Condition")]
                ),
              ]
            ),
            _vm._v(" "),
            _c("b-dropdown-item", { attrs: { to: "/contact-details" } }, [
              _c(
                "span",
                {
                  domProps: {
                    textContent: _vm._s(
                      _vm.$t("global.menu.entities.contactDetails")
                    ),
                  },
                },
                [_vm._v("Contact Details")]
              ),
            ]),
            _vm._v(" "),
            _c("b-dropdown-item", { attrs: { to: "/email" } }, [
              _c(
                "span",
                {
                  domProps: {
                    textContent: _vm._s(_vm.$t("global.menu.entities.email")),
                  },
                },
                [_vm._v("Email")]
              ),
            ]),
            _vm._v(" "),
            _c("b-dropdown-item", { attrs: { to: "/phone" } }, [
              _c(
                "span",
                {
                  domProps: {
                    textContent: _vm._s(_vm.$t("global.menu.entities.phone")),
                  },
                },
                [_vm._v("Phone")]
              ),
            ]),
            _vm._v(" "),
            _c("b-dropdown-item", { attrs: { to: "/comment" } }, [
              _c(
                "span",
                {
                  domProps: {
                    textContent: _vm._s(_vm.$t("global.menu.entities.comment")),
                  },
                },
                [_vm._v("Comment")]
              ),
            ]),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }